export default __webpack_public_path__ + "scripts/resources/assignments/en/Stoichiometry/oracle-temp-3-not-hidden/assignment.json";